import { Button } from '@progress/kendo-react-buttons';
import { FC } from 'react';

interface IProps {
    text?: string;
    disabled?: boolean;
    themeColor?: 'base' | 'primary' | 'secondary' | 'tertiary' | 'info' | 'success' | 'warning' | 'error' | 'dark' | 'light' | 'inverse';
    openCreateModal: Function;
}

const ListItemCreateButton: FC<IProps> = (props) => {
    return (
        <div id="child" style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
                id="itemCreateModal"
                themeColor={props.themeColor === undefined ? 'primary' : props.themeColor}
                onClick={() => props.openCreateModal(true)}
                style={{ margin: '10px', height: '70px' }}
                icon="add"
                disabled={props.disabled === undefined ? false : props.disabled}
                type="button"
            >
                {props.text === undefined ? 'Sukurti naują' : props.text}
            </Button>
        </div>
    );
};

export default ListItemCreateButton;
